<template>
  <div>

    <div class="title">
      Claim Airdrop
    </div>

    <div class="des">First, <span>connect your wallet</span>. And check for UNIT Airdrop eligibility</div>
    <mmLogin @success="getAccount" />
  </div>
</template>

<script>
import mmLogin from './mmLogin.vue'
export default {
  components: {
    mmLogin
  },
  data() {
    return {

    }
  },
  methods: {
    getAccount(val) {
      this.$emit('loginSuccess', val)
    }
  }
}
</script>

<style scoped>
.title{
  margin-top: 0.96rem;
  font-size: 0.44rem;
  font-family: DMSans-Bold, DMSans;
  font-weight: bold;
  color: #1F1F1F;
  line-height: 0.58rem;
}
.des{
  font-size: 0.24rem;
  font-family: DMSans-Regular, DMSans;
  font-weight: 400;
  color: #4C4C4C;
  line-height: 0.32rem;
}
.des span{
  font-weight: bold;
}

</style>
